import { z } from 'zod';
import { genericAddressSchema, evmChainSlugSchema, solanaChainSlugSchema, supportedChainSlugSchema, symbolSchema } from './common.js';
export const getPortfolioParamsSchema = z.object({
    chain: supportedChainSlugSchema,
    address: genericAddressSchema,
    blockHeight: z.number().int().nonnegative().optional(),
}).strict();
export const portfolioTokenSchema = z.object({
    chain: evmChainSlugSchema,
    address: genericAddressSchema,
    symbol: symbolSchema,
    name: z.string().min(1),
    balance: z.string().min(1),
    decimals: z.number().int().nonnegative(),
    priceUsd: z.union([z.number(), z.null()]),
    valueUsd: z.union([z.number(), z.null()]),
}).strict();
export const portfolioDataSchema = z.object({
    address: genericAddressSchema,
    chain: evmChainSlugSchema,
    nativeBalance: z.string().min(1),
    nativeSymbol: symbolSchema,
    nativePriceUsd: z.union([z.number(), z.null()]),
    nativeValueUsd: z.union([z.number(), z.null()]),
    tokens: z.array(portfolioTokenSchema),
    totalValueUsd: z.union([z.number(), z.null()]),
}).strict();
// Solana portfolios have a leaner shape than the EVM one: SPL holdings carry no
// USD valuation, and balances come straight from the parsed token account.
export const solanaPortfolioTokenSchema = z.object({
    mint: genericAddressSchema,
    balance: z.string(),
    balanceRaw: z.string(),
    decimals: z.number().int().nonnegative(),
}).strict();
export const solanaPortfolioDataSchema = z.object({
    chain: solanaChainSlugSchema,
    address: genericAddressSchema,
    nativeBalance: z.string().min(1),
    nativeSymbol: z.literal('SOL'),
    tokens: z.array(solanaPortfolioTokenSchema),
}).strict();
